import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { values } from 'lodash'

import { ui } from '../redux'

import Button from '../components/Button'
import Icon from '../components/Icon'

const ICONS = {
    success : 'md/check',
    primary : 'md/info-outline',
    warning : 'go/alert',
    danger  : 'md/close'
}

const Modal = (props) => {
    const { title, message, intent, content, dispatch } = props
    return (
        <div
            id={ `mod-${intent}` }
            tabIndex="-1"
            role="dialog"
            className="modal"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <Button
                            icon={ <Icon name="md/close" /> }
                            className="close"
                            onClick={ () => dispatch(ui.closeModal()) }
                        />
                    </div>
                    <div className="modal-body">
                        <div className="text-center">
                            <div className={ `text-${intent}` }><Icon name={ ICONS[intent] } size={ 40 } /></div>
                            <h3>{ title }</h3>
                            { message && <p>{ message }</p> }
                            <div className="xs-mt-20">
                                { content }
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer" />
                </div>
            </div>
        </div>
    )
}

Modal.propTypes = {
    title    : PropTypes.string,
    message  : PropTypes.string,
    intent   : PropTypes.oneOf(values(ui.INTENT)),
    content  : PropTypes.object,
    dispatch : PropTypes.func.isRequired
}

Modal.defaultProps = {
    intent: 'success'
}

export default connect()(Modal)
